import React, { useState } from 'react';
import { ToolbarButton } from '@fourthwall/components';
import { DownloadIcon } from '@fourthwall/icons';
export const ReportExportButton = ({ onExport }) => {
    const [isExporting, setIsExporting] = useState(false);
    const handleExport = async () => {
        setIsExporting(true);
        await onExport();
        setIsExporting(false);
    };
    return (React.createElement(ToolbarButton, { label: "Export", isLoading: isExporting, icon: DownloadIcon, onClick: handleExport }));
};
